export default function ComingSoon() {
  return (
    <div style={{
      minHeight: '100vh', background: '#0D1117',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, sans-serif',
      color: '#E8EAF6',
    }}>
      <div style={{ textAlign: 'center', padding: '2rem', maxWidth: 500 }}>
        <div style={{ fontSize: 64, marginBottom: '1.5rem' }}>📖</div>
        <h1 style={{
          fontSize: '2rem', fontWeight: 800, marginBottom: '0.75rem',
          background: 'linear-gradient(135deg, #5B6EE8, #8B5CF6)',
          WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
        }}>
          Manna of Life
        </h1>
        <p style={{ color: '#8892B0', fontSize: '1rem', lineHeight: 1.7, marginBottom: '2rem' }}>
          We're building something meaningful.<br />
          Our site will be ready soon.
        </p>
        <span style={{
          display: 'inline-block',
          background: 'rgba(91,110,232,0.15)',
          border: '1px solid rgba(91,110,232,0.3)',
          color: '#A5B4FC', borderRadius: 20,
          padding: '6px 18px', fontSize: 13,
          fontWeight: 600, letterSpacing: 1, textTransform: 'uppercase',
        }}>
          🚧 Under Construction
        </span>
      </div>
    </div>
  );
}